module.exports = __webpack_public_path__ + "static/Purple_Worm-78d1df788f6834d7215f289debf5ea8e.jpg";